import { BreedSchema } from '../types/breed';

export const PureDogBreedList: BreedSchema[] = [
  { id: '60', type: 'dog', breedName: 'Affenpinscher' },
  { id: '61', type: 'dog', breedName: 'Afghan' },
  { id: '62', type: 'dog', breedName: 'African Crested Dog' },
  { id: '63', type: 'dog', breedName: 'African Hairless' },
  { id: 'Decline', type: 'dog', breedName: 'Africanis' },
  { id: 'Decline', type: 'dog', breedName: 'Aidi' },
  { id: '64', type: 'dog', breedName: 'Airedale Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Akbash' },
  { id: '65', type: 'dog', breedName: 'Akita' },
  { id: 'Decline', type: 'dog', breedName: 'Aksaray Malaklisi' },
  { id: 'Decline', type: 'dog', breedName: 'Alano Espanol' },
  { id: 'Decline', type: 'dog', breedName: 'Alapaha Blue Blood Bulldog' },
  { id: 'Decline', type: 'dog', breedName: 'Alaskan Klee Kai' },
  { id: '66', type: 'dog', breedName: 'Alaskan Malamute' },
  { id: 'Decline', type: 'dog', breedName: 'Alaunt' },
  { id: 'Decline', type: 'dog', breedName: 'Alopekis' },
  { id: 'Decline', type: 'dog', breedName: 'Alpine Mastiff' },
  { id: '305', type: 'dog', breedName: 'American Bull Dog' },
  { id: 'Decline', type: 'dog', breedName: 'American Bully' },
  { id: '67', type: 'dog', breedName: 'American Cocker Spaniel' },
  { id: 'Decline', type: 'dog', breedName: 'American Hairless Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'American Leopard Hound' },
  { id: 'Decline', type: 'dog', breedName: 'American Staffordshire Terrier' },
  { id: '68', type: 'dog', breedName: 'American Water Spaniel' },
  { id: '69', type: 'dog', breedName: 'Anatolian Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Anglo-Francais de Petite Venerie' },
  { id: 'Decline', type: 'dog', breedName: 'Appenzeller Sennenhund' },
  { id: 'Decline', type: 'dog', breedName: 'Argentine Polar Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Ariege Pointer' },
  { id: 'Decline', type: 'dog', breedName: 'Ariegeois' },
  { id: 'Decline', type: 'dog', breedName: 'Armant' },
  { id: 'Decline', type: 'dog', breedName: 'Armenian Gampr' },
  { id: 'Decline', type: 'dog', breedName: 'Artois Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Assyrian Mastiff' },
  { id: '70', type: 'dog', breedName: 'Australian Cattle Dog' },
  { id: '71', type: 'dog', breedName: 'Australian Dingo' },
  { id: '72', type: 'dog', breedName: 'Australian Kelpie' },
  { id: '73', type: 'dog', breedName: 'Australian Shepherd' },
  { id: '74', type: 'dog', breedName: 'Australian Silky Terrier' },
  { id: '70', type: 'dog', breedName: 'Australian Stumpy Tail Cattle Dog' },
  { id: '75', type: 'dog', breedName: 'Australian Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Austrian Black and Tan Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Austrian Pinscher' },
  { id: '76', type: 'dog', breedName: 'Azawakh' },
  { id: 'Decline', type: 'dog', breedName: 'Bac Ha dog' },
  { id: 'Decline', type: 'dog', breedName: 'Bakharwal dog' },
  { id: 'Decline', type: 'dog', breedName: 'Banjara Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Bankhar Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Barak hound' },
  { id: 'Decline', type: 'dog', breedName: 'Barbado da Terceira' },
  { id: 'Decline', type: 'dog', breedName: 'Barbet' },
  { id: '77', type: 'dog', breedName: 'Basenji' },
  { id: 'Decline', type: 'dog', breedName: 'Basque Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Basset Artesien Normand' },
  { id: '78', type: 'dog', breedName: 'Basset Bleu De Gascogne (Imp)' },
  { id: '79', type: 'dog', breedName: 'Basset Fauve De Bretagne' },
  { id: '80', type: 'dog', breedName: 'Basset Griffon Vendeen (Grand)' },
  { id: '81', type: 'dog', breedName: 'Basset Griffon Vendeen (Petit)' },
  { id: '82', type: 'dog', breedName: 'Basset Hound' },
  { id: '83', type: 'dog', breedName: 'Bavarian Mountain Hound (Imp)' },
  { id: '84', type: 'dog', breedName: 'Beagle' },
  { id: 'Decline', type: 'dog', breedName: 'Beagle-Harrier' },
  { id: '85', type: 'dog', breedName: 'Bearded Collie' },
  { id: '86', type: 'dog', breedName: 'Beauceron (Imp)' },
  { id: '87', type: 'dog', breedName: 'Bedlington Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Belgian Mastiff' },
  { id: '91', type: 'dog', breedName: 'Belgian Shepherd' },
  { id: '88', type: 'dog', breedName: 'Belgian Shepherd Dog' },
  { id: '89', type: 'dog', breedName: 'Belgian Shepherd Dog (Groenendael)' },
  { id: '90', type: 'dog', breedName: 'Belgian Shepherd Dog (Laekenois)' },
  { id: '91', type: 'dog', breedName: 'Belgian Shepherd Dog (Malinois)' },
  { id: '92', type: 'dog', breedName: 'Belgian Shepherd Dog (Tervueren)' },
  { id: '93', type: 'dog', breedName: 'Bergamasco (Imp)' },
  { id: 'Decline', type: 'dog', breedName: 'Berger Picard' },
  { id: '94', type: 'dog', breedName: 'Bernese Mountain Dog' },
  { id: '95', type: 'dog', breedName: 'Bichon Frise' },
  { id: 'Decline', type: 'dog', breedName: 'Billy' },
  { id: '96', type: 'dog', breedName: 'Black And Tan English Toy Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Black Mouth Cur' },
  { id: '97', type: 'dog', breedName: 'Bloodhound' },
  { id: '28', type: 'dog', breedName: 'Blue Belton' },
  { id: 'Decline', type: 'dog', breedName: 'Blue Lacy' },
  { id: 'Decline', type: 'dog', breedName: 'Blue Paul Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Boerboel' },
  { id: 'Decline', type: 'dog', breedName: 'Bohemian Shepherd' },
  { id: '98', type: 'dog', breedName: 'Bolognese' },
  { id: '99', type: 'dog', breedName: 'Border Collie' },
  { id: '100', type: 'dog', breedName: 'Border Terrier' },
  { id: '101', type: 'dog', breedName: 'Borzoi' },
  { id: '102', type: 'dog', breedName: 'Boston Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Bouvier des Ardennes' },
  { id: '103', type: 'dog', breedName: 'Bouvier Des Flandres' },
  { id: '104', type: 'dog', breedName: 'Boxer' },
  { id: '105', type: 'dog', breedName: 'Bracco Italiano' },
  { id: 'Decline', type: 'dog', breedName: `Braque d'Auvergne` },
  { id: 'Decline', type: 'dog', breedName: 'Braque du Bourbonnais' },
  { id: 'Decline', type: 'dog', breedName: 'Braque Dupuy' },
  { id: '172', type: 'dog', breedName: 'Braque Francais' },
  { id: 'Decline', type: 'dog', breedName: 'Braque Saint-Germain' },
  { id: '106', type: 'dog', breedName: 'Briard' },
  { id: '107', type: 'dog', breedName: 'Brittany' },
  { id: 'Decline', type: 'dog', breedName: 'Broholmer' },
  { id: 'Decline', type: 'dog', breedName: 'Bruno Jura Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Buckhound' },
  { id: 'Decline', type: 'dog', breedName: 'Bucovina Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Bull and terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Bull Arab' },
  { id: '108', type: 'dog', breedName: 'Bull Terrier' },
  { id: '109', type: 'dog', breedName: 'Bull Terrier (Miniature)' },
  { id: '110', type: 'dog', breedName: 'Bulldog (English)' },
  { id: '111', type: 'dog', breedName: 'Bulldog (Toy)' },
  { id: 'Decline', type: 'dog', breedName: 'Bullenbeisser' },
  { id: '112', type: 'dog', breedName: 'Bullmastiff' },
  { id: 'Decline', type: 'dog', breedName: 'Bully Kutta' },
  { id: 'Decline', type: 'dog', breedName: 'Burgos Pointer' },
  { id: 'Decline', type: 'dog', breedName: 'Ca de Bou' },
  { id: 'Decline', type: 'dog', breedName: 'Ca Me Mallorqui' },
  { id: '113', type: 'dog', breedName: 'Cairn Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Calupoh' },
  { id: 'Decline', type: 'dog', breedName: 'Campeiro Bulldog' },
  { id: 'Decline', type: 'dog', breedName: 'Can de Chira' },
  { id: 'Decline', type: 'dog', breedName: 'Can de Palleiro' },
  { id: '114', type: 'dog', breedName: 'Canaan Dog' },
  { id: '115', type: 'dog', breedName: 'Canadian Eskimo Dog' },
  { id: '116', type: 'dog', breedName: 'Canadian Inuit' },
  { id: 'Decline', type: 'dog', breedName: 'Cane Corso' },
  { id: 'Decline', type: 'dog', breedName: 'Cane di Oropa' },
  { id: 'Decline', type: 'dog', breedName: 'Cane Paratore' },
  { id: 'Decline', type: 'dog', breedName: 'Cantabrian Water Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Cao da Serra de Aires' },
  { id: 'Decline', type: 'dog', breedName: 'Cao de Castro Laboreiro' },
  { id: 'Decline', type: 'dog', breedName: 'Cao de Gado Transmontano' },
  { id: 'Decline', type: 'dog', breedName: 'Cao Fila de Sao Miguel' },
  { id: 'Decline', type: 'dog', breedName: 'Carea Castellano Manchego' },
  { id: 'Decline', type: 'dog', breedName: 'Carea Leones' },
  { id: 'Decline', type: 'dog', breedName: 'Carolina Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Carpathian Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Catahoula Leopard Dog' },
  { id: '117', type: 'dog', breedName: 'Catalan Sheepdog - Wto' },
  { id: 'Decline', type: 'dog', breedName: 'Caucasian Shepherd Dog' },
  { id: '118', type: 'dog', breedName: 'Cavalier King Charles Spaniel' },
  { id: '119', type: 'dog', breedName: 'Central Asian Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Cesky Fousek' },
  { id: '120', type: 'dog', breedName: 'Cesky Terrier' },
  { id: '121', type: 'dog', breedName: 'Chesapeake Bay Retriever' },
  { id: 'Decline', type: 'dog', breedName: 'Chien Francais Blanc et Noir' },
  { id: 'Decline', type: 'dog', breedName: 'Chien Francais Blanc et Orange' },
  { id: 'Decline', type: 'dog', breedName: 'Chien Francais Tricolore' },
  { id: 'Decline', type: 'dog', breedName: 'Chien-gris' },
  { id: '122', type: 'dog', breedName: 'Chihuahua' },
  { id: '123', type: 'dog', breedName: 'Chihuahua (Long Coat)' },
  { id: '124', type: 'dog', breedName: 'Chihuahua (Smooth Coat)' },
  { id: 'Decline', type: 'dog', breedName: 'Chilean Terrier' },
  { id: '125', type: 'dog', breedName: 'Chinese Crested' },
  { id: '125', type: 'dog', breedName: 'Chinese Crested Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Chinook' },
  { id: 'Decline', type: 'dog', breedName: 'Chippiparai' },
  { id: 'Decline', type: 'dog', breedName: 'Chiribaya Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Chongqing dog' },
  { id: 'Decline', type: 'dog', breedName: 'Chortai' },
  { id: '126', type: 'dog', breedName: 'Chow Chow' },
  { id: 'Decline', type: 'dog', breedName: 'Chukotka sled dog' },
  { id: 'Decline', type: 'dog', breedName: 'Cimarron Uruguayo' },
  { id: '127', type: 'dog', breedName: `Cirneco Dell'Etna (Imp)` },
  { id: '128', type: 'dog', breedName: 'Clumber Spaniel' },
  { id: '129', type: 'dog', breedName: 'Cocker Spaniel' },
  { id: '130', type: 'dog', breedName: 'Cockerpoo' },
  { id: '131', type: 'dog', breedName: 'Collie (Rough)' },
  { id: '132', type: 'dog', breedName: 'Collie (Smooth)' },
  { id: 'Decline', type: 'dog', breedName: 'Colombian fino hound' },
  { id: 'Decline', type: 'dog', breedName: 'Continental bulldog' },
  { id: '133', type: 'dog', breedName: 'Continental Landseer' },
  { id: '134', type: 'dog', breedName: 'Coonhound' },
  { id: 'Decline', type: 'dog', breedName: 'Cordoba fighting dog' },
  { id: '135', type: 'dog', breedName: 'Corgi' },
  { id: '136', type: 'dog', breedName: 'Coton De Tulear (Imp)' },
  { id: 'Decline', type: 'dog', breedName: 'Cretan Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Croatian Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Cumberland Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Cur' },
  { id: '137', type: 'dog', breedName: 'Curly Coated Retriever' },
  { id: 'Decline', type: 'dog', breedName: 'Cursinu' },
  { id: 'Decline', type: 'dog', breedName: 'Czechoslovakian Wolfdog' },
  { id: '138', type: 'dog', breedName: 'Dachsbracke' },
  { id: '139', type: 'dog', breedName: 'Dachshund' },
  { id: '140', type: 'dog', breedName: 'Dachshund (Long-Haired)' },
  { id: '141', type: 'dog', breedName: 'Dachshund (Miniature Long-Haired)' },
  { id: '306', type: 'dog', breedName: 'Dachshund (Miniature Short Hair)' },
  { id: '142', type: 'dog', breedName: 'Dachshund (Miniature Smooth-Haired)' },
  { id: '143', type: 'dog', breedName: 'Dachshund (Miniature Wire-Haired)' },
  { id: '144', type: 'dog', breedName: 'Dachshund (Smooth-Haired)' },
  { id: '145', type: 'dog', breedName: 'Dachshund (Wire-Haired)' },
  { id: 'Decline', type: 'dog', breedName: 'Dalbo dog' },
  { id: '146', type: 'dog', breedName: 'Dalmatian' },
  { id: '147', type: 'dog', breedName: 'Dandie Dinmont Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Danish Spitz' },
  { id: 'Decline', type: 'dog', breedName: 'Danish-Swedish Farmdog' },
  { id: '148', type: 'dog', breedName: 'Deerhound' },
  { id: 'Decline', type: 'dog', breedName: 'Denmark Feist' },
  { id: '149', type: 'dog', breedName: 'Dobermann' },
  { id: 'Decline', type: 'dog', breedName: 'Dogo Argentino' },
  { id: 'Decline', type: 'dog', breedName: 'Dogo Cubano' },
  { id: 'Decline', type: 'dog', breedName: 'Dogo Guatemalteco' },
  { id: 'Decline', type: 'dog', breedName: 'Dogo Sardesco' },
  { id: '150', type: 'dog', breedName: 'Dogue De Bordeaux' },
  { id: '151', type: 'dog', breedName: 'Dogue De Bordeaux (Imp)' },
  { id: 'Decline', type: 'dog', breedName: 'Donggyeongi' },
  { id: '152', type: 'dog', breedName: 'Drentse Partridge Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Drever' },
  { id: 'Decline', type: 'dog', breedName: 'Dunker' },
  { id: 'Decline', type: 'dog', breedName: 'Dutch Shepherd' },
  { id: 'Decline', type: 'dog', breedName: 'Dutch Smoushond' },
  { id: 'Decline', type: 'dog', breedName: 'East European Shepherd' },
  { id: 'Decline', type: 'dog', breedName: 'East Siberian Laika' },
  { id: 'Decline', type: 'dog', breedName: 'Ecuadorian Hairless Dog' },
  { id: '153', type: 'dog', breedName: 'Elkhound' },
  { id: '154', type: 'dog', breedName: 'English Bull Terrier' },
  { id: '233', type: 'dog', breedName: 'English Mastiff' },
  { id: '155', type: 'dog', breedName: 'English Pointer' },
  { id: '156', type: 'dog', breedName: 'English Setter' },
  { id: 'Decline', type: 'dog', breedName: 'English Shepherd' },
  { id: '157', type: 'dog', breedName: 'English Springer Spaniel' },
  { id: '158', type: 'dog', breedName: 'English Toy Terrier (Black & Tan)' },
  { id: 'Decline', type: 'dog', breedName: 'English White Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Entlebucher Mountain Dog' },
  { id: '159', type: 'dog', breedName: 'Eskimo Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Estonian Hound' },
  { id: '160', type: 'dog', breedName: 'Estrela Mountain Dog' },
  { id: '161', type: 'dog', breedName: 'Eurasier - Wto' },
  { id: 'Decline', type: 'dog', breedName: 'Extinct breeds, varieties and types' },
  { id: '307', type: 'dog', breedName: 'Farm Collie' },
  { id: '162', type: 'dog', breedName: 'Felland Terrier' },
  { id: '163', type: 'dog', breedName: 'Field Spaniel' },
  { id: 'Decline', type: 'dog', breedName: 'Fila Brasileiro' },
  { id: 'Decline', type: 'dog', breedName: 'Fila da Terceira' },
  { id: 'Decline', type: 'dog', breedName: 'Finnish Hound' },
  { id: '164', type: 'dog', breedName: 'Finnish Lapphund' },
  { id: '165', type: 'dog', breedName: 'Finnish Spitz' },
  { id: '166', type: 'dog', breedName: 'Flat Coated Retriever' },
  { id: '167', type: 'dog', breedName: 'Fox Terrier' },
  { id: '168', type: 'dog', breedName: 'Fox Terrier (Smooth)' },
  { id: '169', type: 'dog', breedName: 'Fox Terrier (Wire)' },
  { id: '170', type: 'dog', breedName: 'Foxhound' },
  { id: '171', type: 'dog', breedName: 'French Bulldog' },
  { id: 'Decline', type: 'dog', breedName: 'Fuegian dog' },
  { id: 'Decline', type: 'dog', breedName: 'Galgo Espanol' },
  { id: 'Decline', type: 'dog', breedName: 'Garafian Shepherd' },
  { id: '172', type: 'dog', breedName: 'Gascoigne' },
  { id: 'Decline', type: 'dog', breedName: 'Gascon Saintongeois' },
  { id: 'Decline', type: 'dog', breedName: 'Georgian Shepherd' },
  { id: 'Decline', type: 'dog', breedName: 'German Hound' },
  { id: '173', type: 'dog', breedName: 'German Longhaired Pointer (Imp)' },
  { id: '174', type: 'dog', breedName: 'German Pinscher' },
  { id: '175', type: 'dog', breedName: 'German Pointer' },
  { id: 'Decline', type: 'dog', breedName: 'German Roughhaired Pointer' },
  { id: '176', type: 'dog', breedName: 'German Shepherd (Alsatian)' },
  { id: '177', type: 'dog', breedName: 'German Shorthaired Pointer' },
  { id: '178', type: 'dog', breedName: 'German Spitz' },
  { id: '179', type: 'dog', breedName: 'German Spitz (Klein)' },
  { id: '180', type: 'dog', breedName: 'German Spitz (Mittel)' },
  { id: '181', type: 'dog', breedName: 'German Spitz Klein Development Register' },
  { id: '182', type: 'dog', breedName: 'German Spitz Mittel Development Register' },
  { id: '183', type: 'dog', breedName: 'German Wire Haired Pointer' },
  { id: '183', type: 'dog', breedName: 'German Wirehaired Pointer' },
  { id: '184', type: 'dog', breedName: 'Giant Schnauzer' },
  { id: '185', type: 'dog', breedName: 'Glen Of Imaal Terrier' },
  { id: '186', type: 'dog', breedName: 'Golden Retriever' },
  { id: 'Decline', type: 'dog', breedName: 'Gonczy Polski' },
  { id: '187', type: 'dog', breedName: 'Gordon Setter' },
  { id: 'Decline', type: 'dog', breedName: 'Grand Anglo-Francais Blanc et Noir' },
  { id: 'Decline', type: 'dog', breedName: 'Grand Anglo-Francais Blanc et Orange' },
  { id: 'Decline', type: 'dog', breedName: 'Grand Anglo-Francais Tricolore' },
  { id: '188', type: 'dog', breedName: 'Grand Bleu De Gascogne (Imp)' },
  { id: '189', type: 'dog', breedName: 'Grand Bleu De Gascoigne' },
  { id: '79', type: 'dog', breedName: 'Grand Fauve de Bretagne' },
  { id: '190', type: 'dog', breedName: 'Great Dane' },
  { id: 'Decline', type: 'dog', breedName: 'Greater Swiss Mountain Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Greek Harehound' },
  { id: 'Decline', type: 'dog', breedName: 'Greek Shepherd' },
  { id: '191', type: 'dog', breedName: 'Greenland Dog' },
  { id: '192', type: 'dog', breedName: 'Greyhound' },
  { id: '308', type: 'dog', breedName: 'Griffon (Rough Haired)' },
  { id: '309', type: 'dog', breedName: 'Griffon Bruxellois' },
  { id: '79', type: 'dog', breedName: 'Griffon Fauve de Bretagne' },
  { id: 'Decline', type: 'dog', breedName: 'Griffon Nivernais' },
  { id: 'Decline', type: 'dog', breedName: 'Gull Dong' },
  { id: 'Decline', type: 'dog', breedName: 'Gull Terrier' },
  { id: '310', type: 'dog', breedName: 'Halden Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Halls Heeler' },
  { id: '311', type: 'dog', breedName: 'Hamiltonstovare' },
  { id: 'Decline', type: 'dog', breedName: 'Hanover Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Hare Indian Dog' },
  { id: '312', type: 'dog', breedName: 'Harrier' },
  { id: '313', type: 'dog', breedName: 'Havanese' },
  { id: 'Decline', type: 'dog', breedName: 'Hawaiian Poi Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Hierran Wolfdog' },
  { id: 'Decline', type: 'dog', breedName: 'Himalayan Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Hmong bobtail dog' },
  { id: 'Decline', type: 'dog', breedName: 'Hokkaido' },
  { id: '314', type: 'dog', breedName: 'Hovawart' },
  { id: '315', type: 'dog', breedName: 'Hungarian Kuvasz' },
  { id: '193', type: 'dog', breedName: 'Hungarian Puli' },
  { id: '194', type: 'dog', breedName: 'Hungarian Vizsla' },
  { id: '195', type: 'dog', breedName: 'Hungarian Wire Haired Vizsla' },
  { id: 'Decline', type: 'dog', breedName: 'Huntaway' },
  { id: '196', type: 'dog', breedName: 'Husky' },
  { id: 'Decline', type: 'dog', breedName: 'Hygen Hound' },
  { id: '197', type: 'dog', breedName: 'Ibizan Hound' },
  { id: '316', type: 'dog', breedName: 'Iceland Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Indian pariah dog' },
  { id: 'Decline', type: 'dog', breedName: 'Indian Spitz' },
  { id: '198', type: 'dog', breedName: 'Irish Red & White Setter' },
  { id: '199', type: 'dog', breedName: 'Irish Setter' },
  { id: '200', type: 'dog', breedName: 'Irish Terrier' },
  { id: '201', type: 'dog', breedName: 'Irish Water Spaniel' },
  { id: '202', type: 'dog', breedName: 'Irish Wolfhound' },
  { id: 'Decline', type: 'dog', breedName: 'Istrian Coarse-haired Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Istrian Shorthaired Hound' },
  { id: '203', type: 'dog', breedName: 'Italian Greyhound' },
  { id: '204', type: 'dog', breedName: 'Italian Spinone' },
  { id: '205', type: 'dog', breedName: 'Jack Russell Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Jagdterrier' },
  { id: 'Decline', type: 'dog', breedName: 'Jamthund' },
  { id: '206', type: 'dog', breedName: 'Japanese Chin' },
  { id: '207', type: 'dog', breedName: 'Japanese Shiba Inu' },
  { id: '208', type: 'dog', breedName: 'Japanese Spitz' },
  { id: 'Decline', type: 'dog', breedName: 'Japanese Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Jindo' },
  { id: 'Decline', type: 'dog', breedName: 'Jonangi' },
  { id: 'Decline', type: 'dog', breedName: 'Kai Ken' },
  { id: 'Decline', type: 'dog', breedName: 'Kaikadi' },
  { id: 'Decline', type: 'dog', breedName: 'Kangal Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Kanni' },
  { id: 'Decline', type: 'dog', breedName: 'Karakachan dog' },
  { id: 'Decline', type: 'dog', breedName: 'Karelian Bear Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Kars' },
  { id: 'Decline', type: 'dog', breedName: 'Karst Shepherd' },
  { id: '317', type: 'dog', breedName: 'Keeshond' },
  { id: 'Decline', type: 'dog', breedName: 'Kerry Beagle' },
  { id: '209', type: 'dog', breedName: 'Kerry Blue Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Khala' },
  { id: '210', type: 'dog', breedName: 'King Charles Spaniel' },
  { id: 'Decline', type: 'dog', breedName: 'King Shepherd' },
  { id: 'Decline', type: 'dog', breedName: `King's White Hound` },
  { id: 'Decline', type: 'dog', breedName: 'Kintamani' },
  { id: 'Decline', type: 'dog', breedName: 'Kishu' },
  { id: 'Decline', type: 'dog', breedName: 'Kokoni' },
  { id: 'Decline', type: 'dog', breedName: 'Kombai' },
  { id: '318', type: 'dog', breedName: 'Komondor (Hungarian Sheepdog)' },
  { id: '319', type: 'dog', breedName: 'Kooikerhondje' },
  { id: 'Decline', type: 'dog', breedName: 'Koolie' },
  { id: 'Decline', type: 'dog', breedName: 'Koyun dog' },
  { id: 'Decline', type: 'dog', breedName: 'Kromfohrlander' },
  { id: 'Decline', type: 'dog', breedName: 'Kuchi' },
  { id: 'Decline', type: 'dog', breedName: 'Kunming dog' },
  { id: 'Decline', type: 'dog', breedName: 'Kurdish Mastiff' },
  { id: 'Decline', type: 'dog', breedName: 'Kuri' },
  { id: '211', type: 'dog', breedName: 'Labradoodle' },
  { id: '212', type: 'dog', breedName: 'Labrador Retriever' },
  { id: '321', type: 'dog', breedName: 'Lagotto Romagnolo' },
  { id: '213', type: 'dog', breedName: 'Lakeland Terrier' },
  { id: '214', type: 'dog', breedName: 'Lancashire Heeler' },
  { id: 'Decline', type: 'dog', breedName: 'Lapponian Herder' },
  { id: 'Decline', type: 'dog', breedName: 'Lapponian Shepherd' },
  { id: '215', type: 'dog', breedName: 'Large Munsterlander' },
  { id: '216', type: 'dog', breedName: 'Leonberger' },
  { id: 'Decline', type: 'dog', breedName: 'Levriero Sardo' },
  { id: '217', type: 'dog', breedName: 'Lhasa Apso' },
  { id: 'Decline', type: 'dog', breedName: 'Liangshan Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Limer' },
  { id: 'Decline', type: 'dog', breedName: 'Lithuanian Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Lobito Herreno' },
  { id: '218', type: 'dog', breedName: 'Long Coat Chihuahua' },
  { id: '219', type: 'dog', breedName: 'Long Haired Dachshund' },
  { id: '322', type: 'dog', breedName: 'Lowchen (Little Lion Dog)' },
  { id: 'Decline', type: 'dog', breedName: 'Lupo Italiano' },
  { id: '220', type: 'dog', breedName: 'Lurcher' },
  { id: 'Decline', type: 'dog', breedName: 'Magyar agar' },
  { id: 'Decline', type: 'dog', breedName: 'Mahratta Greyhound' },
  { id: '221', type: 'dog', breedName: 'Maltese' },
  { id: '96', type: 'dog', breedName: 'Manchester Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Maneto' },
  { id: '222', type: 'dog', breedName: 'Maremma Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Maremmano-Abruzzese Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Marquesan Dog' },
  { id: '223', type: 'dog', breedName: 'Mastiff' },
  { id: 'Decline', type: 'dog', breedName: 'McNab dog' },
  { id: '324', type: 'dog', breedName: 'Mexican Hairless/Xoloitzcuintli (minature)' },
  { id: '325', type: 'dog', breedName: 'Mexican Hairless/Xoloitzcuintli (standard)' },
  { id: '323', type: 'dog', breedName: 'Mexican Hairless/Xoloitzcuintli (toy)' },
  { id: 'Decline', type: 'dog', breedName: 'Miniature American Shepherd' },
  { id: '167', type: 'dog', breedName: 'Miniature Fox Terrier' },
  { id: '224', type: 'dog', breedName: 'Miniature Long Haired Dachshund' },
  { id: '225', type: 'dog', breedName: 'Miniature Pinscher' },
  { id: '226', type: 'dog', breedName: 'Miniature Poodle' },
  { id: '227', type: 'dog', breedName: 'Miniature Schnauzers' },
  { id: '228', type: 'dog', breedName: 'Miniature Short Haired Dachshund' },
  { id: '229', type: 'dog', breedName: 'Miniature Wire Haired Dachshund' },
  { id: 'Decline', type: 'dog', breedName: 'Molossus' },
  { id: 'Decline', type: 'dog', breedName: 'Molossus of Epirus' },
  { id: 'Decline', type: 'dog', breedName: 'Mongrel dog' },
  { id: 'Decline', type: 'dog', breedName: 'Montenegrin Mountain Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Moscow Water Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Mountain Cur' },
  { id: 'Decline', type: 'dog', breedName: 'Mountain Feist' },
  { id: 'Decline', type: 'dog', breedName: 'Mucuchies' },
  { id: 'Decline', type: 'dog', breedName: 'Mudhol Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Mudi' },
  { id: '326', type: 'dog', breedName: 'Munsterlander' },
  { id: '230', type: 'dog', breedName: 'Neapolitan Mastiff' },
  { id: 'Decline', type: 'dog', breedName: 'Nenets Herding Laika' },
  { id: 'Decline', type: 'dog', breedName: 'New Guinea singing dog' },
  { id: 'Decline', type: 'dog', breedName: 'New Zealand Heading Dog' },
  { id: '231', type: 'dog', breedName: 'Newfoundland' },
  { id: '232', type: 'dog', breedName: 'Norfolk Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Norman Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Norrbottenspets' },
  { id: 'Decline', type: 'dog', breedName: 'North Country Beagle' },
  { id: '327', type: 'dog', breedName: 'Northern Inuit' },
  { id: '328', type: 'dog', breedName: 'Norwegian Buhund' },
  { id: '329', type: 'dog', breedName: 'Norwegian Lundehund' },
  { id: '233', type: 'dog', breedName: 'Norwich Terrier' },
  { id: '234', type: 'dog', breedName: 'Nova Scotia Duck Tolling Retriever' },
  { id: 'Decline', type: 'dog', breedName: 'Old Croatian Sighthound' },
  { id: 'Decline', type: 'dog', breedName: 'Old Danish Pointer' },
  { id: 'Decline', type: 'dog', breedName: 'Old English Bulldog' },
  { id: '235', type: 'dog', breedName: 'Old English Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Old English Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Old Spanish Pointer' },
  { id: 'Decline', type: 'dog', breedName: 'Old Welsh Grey Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Olde English Bulldogge' },
  { id: '236', type: 'dog', breedName: 'Otter Hound' },
  { id: '236', type: 'dog', breedName: 'Otterhound' },
  { id: 'Decline', type: 'dog', breedName: 'Pachon Navarro' },
  { id: 'Decline', type: 'dog', breedName: 'Paisley Terrier' },
  { id: '237', type: 'dog', breedName: 'Papillon' },
  { id: '238', type: 'dog', breedName: 'Parson Russell Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Pastore della Lessinia e del Lagorai' },
  { id: 'Decline', type: 'dog', breedName: 'Patagonian Sheepdog' },
  { id: '351', type: 'dog', breedName: 'Patterdale Terrier' },
  { id: '239', type: 'dog', breedName: 'Pekinese' },
  { id: 'Decline', type: 'dog', breedName: 'Perro de Pastor Mallorquin' },
  { id: 'Decline', type: 'dog', breedName: 'Perro de Presa Canario' },
  { id: 'Decline', type: 'dog', breedName: 'Perro de Presa Mallorquin' },
  { id: 'Decline', type: 'dog', breedName: 'Perro Majorero' },
  { id: 'Decline', type: 'dog', breedName: 'Peruvian Inca Orchid' },
  { id: 'Decline', type: 'dog', breedName: 'Phalene' },
  { id: '240', type: 'dog', breedName: 'Pharaoh Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Phu Quoc Ridgeback' },
  { id: 'Decline', type: 'dog', breedName: 'Plott Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Plummer Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Podenco Andaluz' },
  { id: 'Decline', type: 'dog', breedName: 'Podenco Canario' },
  { id: 'Decline', type: 'dog', breedName: 'Podenco Valenciano' },
  { id: '241', type: 'dog', breedName: 'Pointer' },
  { id: 'Decline', type: 'dog', breedName: 'Poitevin' },
  { id: 'Decline', type: 'dog', breedName: 'Polish Greyhound' },
  { id: 'Decline', type: 'dog', breedName: 'Polish Hound' },
  { id: '242', type: 'dog', breedName: 'Polish Lowland Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Polish Tatra Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Polynesian Dog' },
  { id: '243', type: 'dog', breedName: 'Pomeranian' },
  { id: '244', type: 'dog', breedName: 'Poodle (Miniature)' },
  { id: '245', type: 'dog', breedName: 'Poodle (Standard)' },
  { id: '246', type: 'dog', breedName: 'Poodle (Toy)' },
  { id: 'Decline', type: 'dog', breedName: 'Porcelaine' },
  { id: '332', type: 'dog', breedName: 'Portuguese Podengo (Portuguese Warren Hound - Large)' },
  { id: '331', type: 'dog', breedName: 'Portuguese Podengo (Portuguese Warren Hound - Medium )' },
  { id: '330', type: 'dog', breedName: 'Portuguese Podengo (Portuguese Warren Hound - Small)' },
  { id: 'Decline', type: 'dog', breedName: 'Portuguese Pointer' },
  { id: '333', type: 'dog', breedName: 'Portuguese Water Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Posavac Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Prazsky Krysarik' },
  { id: 'Decline', type: 'dog', breedName: 'Pudelpointer' },
  { id: '247', type: 'dog', breedName: 'Pug' },
  { id: 'Decline', type: 'dog', breedName: 'Pumi' },
  { id: 'Decline', type: 'dog', breedName: 'Pungsan dog' },
  { id: '334', type: 'dog', breedName: 'Pyrenean Mastiff' },
  { id: '248', type: 'dog', breedName: 'Pyrenean Mountain Dog' },
  { id: '335', type: 'dog', breedName: 'Pyrenean Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Rache' },
  { id: 'Decline', type: 'dog', breedName: 'Rafeiro do Alentejo' },
  { id: '  Decline', type: 'dog', breedName: 'Rajapalayam' },
  { id: 'Decline', type: 'dog', breedName: 'Rampur Greyhound' },
  { id: 'Decline', type: 'dog', breedName: 'Rastreador Brasileiro' },
  { id: 'Decline', type: 'dog', breedName: 'Rat Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Ratonero Bodeguero Andaluz' },
  { id: 'Decline', type: 'dog', breedName: 'Ratonero Mallorquin' },
  { id: 'Decline', type: 'dog', breedName: 'Ratonero Murciano' },
  { id: 'Decline', type: 'dog', breedName: 'Ratonero Valenciano' },
  { id: '249', type: 'dog', breedName: 'Retriever (Curly Coated)' },
  { id: '250', type: 'dog', breedName: 'Retriever (Flat Coated)' },
  { id: '251', type: 'dog', breedName: 'Retriever (Golden)' },
  { id: '252', type: 'dog', breedName: 'Retriever (Labrador)' },
  { id: '253', type: 'dog', breedName: 'Retrievers' },
  { id: '254', type: 'dog', breedName: 'Rhodesian Ridgeback' },
  { id: 'Decline', type: 'dog', breedName: 'Romanian Mioritic Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Romanian Raven Shepherd Dog' },
  { id: '255', type: 'dog', breedName: 'Rottweiler' },
  { id: '256', type: 'dog', breedName: 'Rough Collie' },
  { id: '336', type: 'dog', breedName: 'Russian Black Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Russian Toy' },
  { id: 'Decline', type: 'dog', breedName: 'Russo-European Laika' },
  { id: 'Decline', type: 'dog', breedName: 'Ryukyu Inu' },
  { id: 'Decline', type: 'dog', breedName: 'Saarloos Wolfdog' },
  { id: 'Decline', type: 'dog', breedName: 'Sabueso Espanol' },
  { id: 'Decline', type: 'dog', breedName: 'Saint Hubert Jura Hound' },
  { id: 'Decline', type: 'dog', breedName: `Saint John's water dog` },
  { id: 'Decline', type: 'dog', breedName: 'Saint Miguel Cattle Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Salish Wool Dog' },
  { id: '257', type: 'dog', breedName: 'Saluki' },
  { id: '258', type: 'dog', breedName: 'Samoyed' },
  { id: 'Decline', type: 'dog', breedName: 'Sapsali' },
  { id: 'Decline', type: 'dog', breedName: 'Sarabi dog' },
  { id: 'Decline', type: 'dog', breedName: 'Sardinian Shepherd Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Sarplaninac' },
  { id: 'Decline', type: 'dog', breedName: 'Schapendoes' },
  { id: 'Decline', type: 'dog', breedName: 'Schillerstovare' },
  { id: '337', type: 'dog', breedName: 'Schipperke' },
  { id: '259', type: 'dog', breedName: 'Schnauzers' },
  { id: 'Decline', type: 'dog', breedName: 'Schweizerischer Niederlaufhund' },
  { id: '260', type: 'dog', breedName: 'Scottish Terrier' },
  { id: '297', type: 'dog', breedName: 'Sealyham Terrier' },
  { id: 'Decline', type: 'dog', breedName: `Segugio dell'Appennino` },
  { id: '338', type: 'dog', breedName: 'Segugio Italiano' },
  { id: 'Decline', type: 'dog', breedName: 'Segugio Maremmano' },
  { id: 'Decline', type: 'dog', breedName: 'Serbian Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Serbian Tricolour Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Serrano Bulldog' },
  { id: '261', type: 'dog', breedName: 'Setters' },
  { id: '262', type: 'dog', breedName: 'Shar Pei' },
  { id: '263', type: 'dog', breedName: 'Shetland Sheepdog' },
  { id: '264', type: 'dog', breedName: 'Shih Tzu' },
  { id: 'Decline', type: 'dog', breedName: 'Shikoku' },
  { id: 'Decline', type: 'dog', breedName: 'Shiloh Shepherd' },
  { id: '265', type: 'dog', breedName: 'Siberian Husky' },
  { id: 'Decline', type: 'dog', breedName: 'Silken Windhound' },
  { id: 'Decline', type: 'dog', breedName: 'Sinhala Hound' },
  { id: '339', type: 'dog', breedName: 'Skye Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Sleuth hound' },
  { id: '266', type: 'dog', breedName: 'Sloughi' },
  { id: '340', type: 'dog', breedName: 'Slovakian Rough-haired Pointer' },
  { id: 'Decline', type: 'dog', breedName: 'Slovensky Cuvac' },
  { id: 'Decline', type: 'dog', breedName: 'Slovensky Kopov' },
  { id: 'Decline', type: 'dog', breedName: 'Smalandstovare' },
  { id: 'Decline', type: 'dog', breedName: 'Small Greek domestic dog' },
  { id: '267', type: 'dog', breedName: 'Small Munsterlander' },
  { id: 'Decline', type: 'dog', breedName: 'Smithfield' },
  { id: '268', type: 'dog', breedName: 'Smooth Collie' },
  { id: '269', type: 'dog', breedName: 'Smooth Fox Terrier' },
  { id: '270', type: 'dog', breedName: 'Smooth Haired Dachshund' },
  { id: '271', type: 'dog', breedName: 'Soft Coated Wheaten Terrier' },
  { id: '271', type: 'dog', breedName: 'Soft-Coated Wheaten Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'South Russian Ovcharka' },
  { id: 'Decline', type: 'dog', breedName: 'Southern Hound' },
  { id: '272', type: 'dog', breedName: 'Spaniel (American Cocker)' },
  { id: '273', type: 'dog', breedName: 'Spaniel (American Water)' },
  { id: '274', type: 'dog', breedName: 'Spaniel (Clumber)' },
  { id: '275', type: 'dog', breedName: 'Spaniel (Cocker)' },
  { id: '276', type: 'dog', breedName: 'Spaniel (English Springer)' },
  { id: '277', type: 'dog', breedName: 'Spaniel (Field)' },
  { id: '278', type: 'dog', breedName: 'Spaniel (Irish Water)' },
  { id: '279', type: 'dog', breedName: 'Spaniel (Sussex)' },
  { id: '280', type: 'dog', breedName: 'Spaniel (Welsh Springer)' },
  { id: '281', type: 'dog', breedName: 'Spaniels' },
  { id: 'Decline', type: 'dog', breedName: 'Spanish Mastiff' },
  { id: '341', type: 'dog', breedName: 'Spanish Water Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Spino degli Iblei' },
  { id: 'Decline', type: 'dog', breedName: 'Sporting Lucas Terrier' },
  { id: '282', type: 'dog', breedName: 'St Bernard' },
  { id: 'Decline', type: 'dog', breedName: 'Stabyhoun' },
  { id: '283', type: 'dog', breedName: 'Staffordshire Bull Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Staghound' },
  { id: '284', type: 'dog', breedName: 'Standard Bull Terrier' },
  { id: '285', type: 'dog', breedName: 'Standard Poodle' },
  { id: '286', type: 'dog', breedName: 'Standard Schnauzer' },
  { id: 'Decline', type: 'dog', breedName: 'Stephens Stock' },
  { id: 'Decline', type: 'dog', breedName: 'Styrian Coarse-haired Hound' },
  { id: '287', type: 'dog', breedName: 'Swedish Lapphund (Imp)' },
  { id: '288', type: 'dog', breedName: 'Swedish Vallhund' },
  { id: 'Decline', type: 'dog', breedName: 'Swinford Bandog' },
  { id: '342', type: 'dog', breedName: 'Swiss Laufhund (Jura)' },
  { id: 'Decline', type: 'dog', breedName: 'Tahitian Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Tahltan Bear Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Taigan' },
  { id: 'Decline', type: 'dog', breedName: 'Taiwan Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Talbot Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Tamaskan Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Tang Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Tazy' },
  { id: 'Decline', type: 'dog', breedName: 'Techichi' },
  { id: 'Decline', type: 'dog', breedName: 'Teddy Roosevelt Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Telomian' },
  { id: 'Decline', type: 'dog', breedName: 'Tenterfield Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Terrier Brasileiro' },
  { id: 'Decline', type: 'dog', breedName: 'Tesem' },
  { id: 'Decline', type: 'dog', breedName: 'Thai Bangkaew Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Thai Ridgeback' },
  { id: 'Decline', type: 'dog', breedName: 'Tibetan Kyi Apso' },
  { id: '289', type: 'dog', breedName: 'Tibetan Mastiff' },
  { id: '290', type: 'dog', breedName: 'Tibetan Spaniel' },
  { id: '291', type: 'dog', breedName: 'Tibetan Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Tonya Finosu' },
  { id: 'Decline', type: 'dog', breedName: 'Torkuz' },
  { id: 'Decline', type: 'dog', breedName: 'Tornjak' },
  { id: 'Decline', type: 'dog', breedName: 'Tosa Inu' },
  { id: '111', type: 'dog', breedName: 'Toy Bulldog' },
  { id: '167', type: 'dog', breedName: 'Toy Fox Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Toy Manchester Terrier' },
  { id: '292', type: 'dog', breedName: 'Toy Poodle' },
  { id: 'Decline', type: 'dog', breedName: 'Transylvanian Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Treeing Cur' },
  { id: 'Decline', type: 'dog', breedName: 'Treeing Feist' },
  { id: 'Decline', type: 'dog', breedName: 'Treeing Tennessee Brindle' },
  { id: 'Decline', type: 'dog', breedName: 'Trigg Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Turnspit dog' },
  { id: 'Decline', type: 'dog', breedName: 'Tyrolean Hound' },
  { id: '343', type: 'dog', breedName: 'Utonagan' },
  { id: 'Decline', type: 'dog', breedName: 'Vikhan' },
  { id: 'Decline', type: 'dog', breedName: 'Villano de Las Encartaciones' },
  { id: 'Decline', type: 'dog', breedName: 'Villanuco de Las Encartaciones' },
  { id: 'Decline', type: 'dog', breedName: 'Volpino Italiano' },
  { id: '293', type: 'dog', breedName: 'Weimaraner' },
  { id: '294', type: 'dog', breedName: 'Welsh Corgi (Cardigan)' },
  { id: '295', type: 'dog', breedName: 'Welsh Corgi (Pembroke)' },
  { id: 'Decline', type: 'dog', breedName: 'Welsh Hillman' },
  { id: 'Decline', type: 'dog', breedName: 'Welsh Hound' },
  { id: 'Decline', type: 'dog', breedName: 'Welsh Sheepdog' },
  { id: '296', type: 'dog', breedName: 'Welsh Springer Spaniel' },
  { id: '297', type: 'dog', breedName: 'Welsh Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'West Country Harrier' },
  { id: '298', type: 'dog', breedName: 'West Highland Terrier' },
  { id: '299', type: 'dog', breedName: 'West Highland White Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'West Siberian Laika' },
  { id: 'Decline', type: 'dog', breedName: 'Wetterhoun' },
  { id: '300', type: 'dog', breedName: 'Whippet' },
  { id: '176', type: 'dog', breedName: 'White Shepherd' },
  { id: '176', type: 'dog', breedName: 'White Swiss Shepherd Dog' },
  { id: '301', type: 'dog', breedName: 'Wire Fox Terrier' },
  { id: '302', type: 'dog', breedName: 'Wire Haired Dachshund' },
  { id: '320', type: 'dog', breedName: 'Wirehaired Pointing Griffon (Korthals)' },
  { id: '303', type: 'dog', breedName: 'Border Collie/Working Sheepdog' },
  { id: 'Decline', type: 'dog', breedName: 'Xiasi Dog' },
  { id: 'Decline', type: 'dog', breedName: 'Yakutian Laika' },
  { id: '304', type: 'dog', breedName: 'Yorkshire Terrier' },
  { id: 'Decline', type: 'dog', breedName: 'Zerdava' },
];
